import React, { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';

// Seating data extracted from the PDF guest list
const SEATING_DATA = [
  // Table 1
  { table: 1, position: 'head', name: 'Ismael Medina' },
  { table: 1, position: 'right-1', name: 'Cristian Medina' },
  { table: 1, position: 'right-2', name: 'Miriam Castro' },
  { table: 1, position: 'right-3', name: 'Arela Medina' },
  { table: 1, position: 'right-4', name: 'Mercedez Rodriguez' },
  { table: 1, position: 'right-5', name: 'Ezequiel Rodriguez' },
  { table: 1, position: 'right-6', name: 'David Mayer' },
  { table: 1, position: 'right-7', name: 'Preethi Siva' },
  { table: 1, position: 'right-8', name: 'Arshiya Ahuja' },
  { table: 1, position: 'right-9', name: 'Reza Kumara' },
  { table: 1, position: 'right-10', name: 'Elliott Woodward' },
  { table: 1, position: 'right-11', name: 'Rui Song' },
  { table: 1, position: 'right-12', name: 'Anying Li' },
  { table: 1, position: 'right-13', name: 'Allison Brown' },
  { table: 1, position: 'left-1', name: 'Julia Regalado' },
  { table: 1, position: 'left-2', name: 'Teddy Medina' },
  { table: 1, position: 'left-3', name: 'Adriel Obed Medina' },
  { table: 1, position: 'left-4', name: 'Mildred Flores' },
  { table: 1, position: 'left-5', name: 'Isaura Morales' },
  { table: 1, position: 'left-6', name: 'David Aviles Morales' },
  { table: 1, position: 'left-7', name: 'Ardavan Amini' },
  { table: 1, position: 'left-8', name: 'Swetha Sriram' },
  { table: 1, position: 'left-9', name: 'Andrea Valdes' },
  { table: 1, position: 'left-10', name: 'Regina Ocariz Arce' },
  { table: 1, position: 'left-11', name: 'Prarena Chailaivanichkul' },
  { table: 1, position: 'left-12', name: 'Pariphat Sinma' },
  { table: 1, position: 'left-13', name: 'Lara Timbo' },
  { table: 1, position: 'left-14', name: 'Erik Nguyen' },

  // Table 2
  { table: 2, position: 'head', name: 'Enid Barillas' },
  { table: 2, position: 'right-1', name: 'Giancarlo Barillas' },
  { table: 2, position: 'right-2', name: 'Crystal Vasquez' },
  { table: 2, position: 'right-3', name: 'Marcelo Barillas' },
  { table: 2, position: 'right-4', name: 'Adriana Cordero' },
  { table: 2, position: 'right-5', name: 'Amanda Leavitt' },
  { table: 2, position: 'right-6', name: 'Mika Leavitt' },
  { table: 2, position: 'right-7', name: 'Ethan Leavitt' },
  { table: 2, position: 'right-8', name: 'Alexandra Barillas' },
  { table: 2, position: 'right-9', name: 'Monica Mandernach' },
  { table: 2, position: 'right-10', name: 'Martina Mandernach' },
  { table: 2, position: 'right-11', name: 'Connie Barillas' },
  { table: 2, position: 'right-12', name: 'Alexandra Barillas' },
  { table: 2, position: 'right-13', name: 'Jacob Packley' },
  { table: 2, position: 'right-14', name: 'Enrique Morales' },
  { table: 2, position: 'left-1', name: 'Francisco Barillas' },
  { table: 2, position: 'left-2', name: 'Pablo Barillas' },
  { table: 2, position: 'left-3', name: 'Alejandro Barillas' },
  { table: 2, position: 'left-4', name: 'Ana Delia Rodriguez' },
  { table: 2, position: 'left-5', name: 'Linda Rivera' },
  { table: 2, position: 'left-6', name: 'Marco Barillas' },
  { table: 2, position: 'left-7', name: 'Carlos Barillas' },
  { table: 2, position: 'left-8', name: 'Maria G Barillas' },
  { table: 2, position: 'left-9', name: 'Cristian Barillas' },
  { table: 2, position: 'left-10', name: 'Emily Ford' },
  { table: 2, position: 'left-11', name: 'Lucy Bonilla' },
  { table: 2, position: 'left-12', name: 'Joan Pellot' },
  { table: 2, position: 'left-13', name: 'Edgar Gonzalez' },
  { table: 2, position: 'left-14', name: '' },

  // Table 3
  { table: 3, position: 'head', name: 'Fernando Yordan' },
  { table: 3, position: 'right-1', name: 'Yvonne Lopez' },
  { table: 3, position: 'right-2', name: 'Agnes Lopez' },
  { table: 3, position: 'right-3', name: 'Vanessa Yordan' },
  { table: 3, position: 'right-4', name: 'Freddie Madera' },
  { table: 3, position: 'right-5', name: 'Freddie Madera' },
  { table: 3, position: 'right-6', name: 'Zaimary Madera' },
  { table: 3, position: 'right-7', name: 'Elsa Ivette Yordan' },
  { table: 3, position: 'right-8', name: 'Nelson Eric Torres' },
  { table: 3, position: 'right-9', name: 'Mitcheell Negron' },
  { table: 3, position: 'right-10', name: 'Michelle Yordan' },
  { table: 3, position: 'right-11', name: 'Asbertly Vargas' },
  { table: 3, position: 'right-12', name: 'Ana Molenari' },
  { table: 3, position: 'right-13', name: 'Tami McMurrian' },
  { table: 3, position: 'left-1', name: 'Nicole Yordan' },
  { table: 3, position: 'left-2', name: 'Ilya Luschitsky' },
  { table: 3, position: 'left-3', name: 'Mila Luschitsky' },
  { table: 3, position: 'left-4', name: 'Cristina Madera' },
  { table: 3, position: 'left-5', name: 'Adriel Ildefonso' },
  { table: 3, position: 'left-6', name: 'Lizandra Aviles' },
  { table: 3, position: 'left-7', name: 'Nelson Javier Torres' },
  { table: 3, position: 'left-8', name: 'Gustavo Yordan' },
  { table: 3, position: 'left-9', name: 'Maritza Gonzalez' },
  { table: 3, position: 'left-10', name: 'Robert Rodriguez' },
  { table: 3, position: 'left-11', name: 'Alexandra Rivera' },
  { table: 3, position: 'left-12', name: 'Adriana Aguilar' },
  { table: 3, position: 'left-13', name: 'Edgar Vazquez' },

  // Table 4
  { table: 4, position: 'head', name: 'Eric Riehl' },
  { table: 4, position: 'right-1', name: 'Armando Fadhel' },
  { table: 4, position: 'right-2', name: 'Maria Roldan' },
  { table: 4, position: 'right-3', name: 'David D\'Achiardi' },
  { table: 4, position: 'right-4', name: 'Arlette Reyes' },
  { table: 4, position: 'right-5', name: 'Stephen Gaffley' },
  { table: 4, position: 'right-6', name: 'Viviana Pequeno' },
  { table: 4, position: 'right-7', name: 'Dennis Garcia' },
  { table: 4, position: 'right-8', name: 'Anthony Erb Lugo' },
  { table: 4, position: 'right-9', name: 'Alberto Mulero' },
  { table: 4, position: 'right-10', name: 'Alex Dalzell' },
  { table: 4, position: 'right-11', name: 'Paola Perez' },
  { table: 4, position: 'right-12', name: 'Priscilla Agosto' },
  { table: 4, position: 'right-13', name: 'James Crowther' },
  { table: 4, position: 'left-1', name: 'Wendi Guraziu' },
  { table: 4, position: 'left-2', name: 'Aidan McLeod' },
  { table: 4, position: 'left-3', name: 'Francisco Sanchez' },
  { table: 4, position: 'left-4', name: 'Dayanna Espinoza' },
  { table: 4, position: 'left-5', name: 'Daniel Huertas' },
  { table: 4, position: 'left-6', name: 'Daniel Prado' },
  { table: 4, position: 'left-7', name: 'Yousif Rouben' },
  { table: 4, position: 'left-8', name: 'Bryan Collazo' },
  { table: 4, position: 'left-9', name: 'Rocio Garcia' },
  { table: 4, position: 'left-10', name: 'Margaret Andersen' },
  { table: 4, position: 'left-11', name: 'Gabriel Ginorio' },
  { table: 4, position: 'left-12', name: 'Marcos Pertierra' },
  { table: 4, position: 'left-13', name: 'Michael Sanabria' },

  // Table 5 - Circle (8 seats, clockwise from 12 o'clock)
  { table: 5, position: 'pos-1', name: 'Adriel Gonzalez' },
  { table: 5, position: 'pos-2', name: 'Dylan Grullon' },
  { table: 5, position: 'pos-3', name: 'Lee Bernick' },
  { table: 5, position: 'pos-4', name: 'Robert Arnolt' },
  { table: 5, position: 'pos-5', name: 'Artem Shkuratov' },
  { table: 5, position: 'pos-6', name: 'Caitlin Shkuratov' },
  { table: 5, position: 'pos-7', name: 'Collin Irwin' },
  { table: 5, position: 'pos-8', name: 'Rachel Hausmann' },

  // Table 6 - Circle (8 seats, clockwise from 12 o'clock)
  { table: 6, position: 'pos-1', name: 'Daniel Kang' },
  { table: 6, position: 'pos-2', name: 'Hayley Sypniewski' },
  { table: 6, position: 'pos-3', name: 'Kelly Yong' },
  { table: 6, position: 'pos-4', name: 'Chris Lo' },
  { table: 6, position: 'pos-5', name: 'Paola Sundaram' },
  { table: 6, position: 'pos-6', name: 'Pedro Colon' },
  { table: 6, position: 'pos-7', name: 'Eric Markunas' },
  { table: 6, position: 'pos-8', name: 'Anais Castellano Solis' },
];

function SeatingChart() {
  const [searchQuery, setSearchQuery] = useState('');
  const [highlightedGuest, setHighlightedGuest] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredGuests, setFilteredGuests] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const tableRefs = useRef({});
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const isSelectingRef = useRef(false);

  // Filter guests when search query changes
  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredGuests([]);
      setShowDropdown(false);
      return;
    }

    const filtered = SEATING_DATA.filter(g =>
      g.name && g.name.toLowerCase().includes(searchQuery.toLowerCase())
    ).slice(0, 10); // Limit to 10 results

    setFilteredGuests(filtered);
    // Only show dropdown if we're not in the middle of selecting a guest
    if (!isSelectingRef.current) {
      setShowDropdown(filtered.length > 0);
    }
    setSelectedIndex(0);
  }, [searchQuery]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
        inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const selectGuest = (guest) => {
    // Set flag to prevent useEffect from reopening dropdown
    isSelectingRef.current = true;

    setSearchQuery(guest.name);
    setHighlightedGuest(guest);
    setShowDropdown(false);

    // Close mobile keyboard
    inputRef.current?.blur();

    // Reset flag after a short delay
    setTimeout(() => {
      isSelectingRef.current = false;
    }, 100);

    // Auto-scroll to the selected table with offset for sticky header
    setTimeout(() => {
      if (tableRefs.current[guest.table]) {
        const element = tableRefs.current[guest.table];
        const yOffset = -250; // Offset to account for sticky header (search + minimap)
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const handleKeyDown = (e) => {
    if (!showDropdown || filteredGuests.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelectedIndex((prev) =>
        prev < filteredGuests.length - 1 ? prev + 1 : prev
      );
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelectedIndex((prev) => prev > 0 ? prev - 1 : prev);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (filteredGuests[selectedIndex]) {
        selectGuest(filteredGuests[selectedIndex]);
        // Close mobile keyboard
        inputRef.current?.blur();
      }
    } else if (e.key === 'Escape') {
      setShowDropdown(false);
      inputRef.current?.blur();
    }
  };

  // Table Layout Minimap
  const renderTableLayoutMinimap = () => {
    const highlightedTable = highlightedGuest?.table;

    const tableStyle = (tableNum) => ({
      borderColor: '#C87941',
      borderWidth: '2px',
      backgroundColor: highlightedTable === tableNum ? '#fef3c7' : 'white',
      boxShadow: highlightedTable === tableNum ? '0 0 0 3px #C87941' : 'none',
      transition: 'all 0.3s ease',
      transform: highlightedTable === tableNum ? 'scale(1.1)' : 'scale(1)',
    });

    return (
      <div className="max-w-xs mx-auto p-2 rounded-lg border-2" style={{ borderColor: '#C87941', backgroundColor: 'white' }}>
        <div className="flex flex-col items-center gap-2">
          {/* D&F Table */}
          <div className="flex justify-center">
            <div
              className="rounded border-2 flex items-center justify-center font-bold"
              style={{ width: '35px', height: '20px', fontSize: '9px', ...tableStyle('DF') }}
            >
              D&F
            </div>
          </div>

          {/* Rectangular Tables Row (4, 3, 2, 1) */}
          <div className="flex gap-1.5 justify-center">
            {[4, 3, 2, 1].map(num => (
              <div
                key={num}
                className="rounded border-2 flex items-center justify-center font-bold"
                style={{ width: '24px', height: '45px', fontSize: '10px', ...tableStyle(num) }}
              >
                {num}
              </div>
            ))}
          </div>

          {/* Circular Tables Row (6, 5) */}
          <div className="flex gap-3 justify-center">
            {[6, 5].map(num => (
              <div
                key={num}
                className="rounded-full border-2 flex items-center justify-center font-bold"
                style={{ width: '28px', height: '28px', fontSize: '10px', ...tableStyle(num) }}
              >
                {num}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderRectangularTable = (tableNumber) => {
    const tableGuests = SEATING_DATA.filter(g => g.table === tableNumber);
    const head = tableGuests.find(g => g.position === 'head');
    const leftSide = [];
    const rightSide = [];

    // Determine max positions for each side dynamically
    const leftPositions = tableGuests.filter(g => g.position.startsWith('left-'));
    const rightPositions = tableGuests.filter(g => g.position.startsWith('right-'));

    const maxLeft = leftPositions.length > 0
      ? Math.max(...leftPositions.map(g => parseInt(g.position.split('-')[1])))
      : 0;
    const maxRight = rightPositions.length > 0
      ? Math.max(...rightPositions.map(g => parseInt(g.position.split('-')[1])))
      : 0;

    // Create arrays with all positions for each side
    for (let i = 1; i <= maxLeft; i++) {
      const leftGuest = tableGuests.find(g => g.position === `left-${i}`);
      leftSide.push(leftGuest || { position: `left-${i}`, name: '', table: tableNumber });
    }

    for (let i = 1; i <= maxRight; i++) {
      const rightGuest = tableGuests.find(g => g.position === `right-${i}`);
      rightSide.push(rightGuest || { position: `right-${i}`, name: '', table: tableNumber });
    }

    const isHighlighted = (guest) => {
      return highlightedGuest &&
        highlightedGuest.table === guest.table &&
        highlightedGuest.position === guest.position;
    };

    const isTableHighlighted = highlightedGuest?.table === tableNumber;

    const SEAT_WIDTH = 100; // Fixed width for smaller screens
    const FIXED_TABLE_HEIGHT = 336; // Fixed table height (13 * 24 + 12 * 2 = 336px)
    const maxSeats = Math.max(leftSide.length, rightSide.length);
    const GAP = 2;
    // Calculate seat height to fit all seats within fixed table height
    const SEAT_HEIGHT = Math.floor((FIXED_TABLE_HEIGHT - (maxSeats - 1) * GAP) / maxSeats);

    return (
      <div
        ref={el => tableRefs.current[tableNumber] = el}
        className={`inline-block p-1 sm:p-2 lg:p-3 rounded-lg transition-all duration-300 transform scale-90 sm:scale-95 lg:scale-100 ${isTableHighlighted ? 'bg-yellow-50 shadow-xl !scale-100' : ''
          }`}
      >
        <h3 className="text-center text-xs sm:text-sm lg:text-base font-bold mb-1 sm:mb-2" style={{ color: '#C87941' }}>
          Table {tableNumber}
        </h3>
        <div className="flex flex-col items-center">
          {/* Head */}
          {head && (
            <div
              className={`px-2 py-1 mb-1 rounded-md border-2 text-center font-medium transition-all flex items-center justify-center ${isHighlighted(head)
                ? 'bg-yellow-300 border-yellow-600 font-bold shadow-lg transform scale-110 z-20'
                : 'bg-gray-50 border-gray-400'
                }`}
              style={{
                width: `${SEAT_WIDTH}px`,
                height: '28px',
                fontSize: '8px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {head.name}
            </div>
          )}

          {/* Table body */}
          <div className="relative flex items-stretch">
            {/* Left side */}
            <div className="flex flex-col" style={{ gap: `${GAP}px` }}>
              {leftSide.map((guest, idx) => (
                <div
                  key={`left-${idx}`}
                  className={`px-1 rounded-md border transition-all flex items-center justify-end ${guest.name && isHighlighted(guest)
                    ? 'bg-yellow-300 border-yellow-600 font-bold shadow-lg transform scale-110 z-20'
                    : guest.name ? 'bg-white border-gray-300' : 'bg-gray-50 border-gray-200'
                    }`}
                  style={{
                    width: `${SEAT_WIDTH}px`,
                    height: `${SEAT_HEIGHT}px`,
                    fontSize: '8px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    paddingRight: '4px'
                  }}
                >
                  {guest.name || '-'}
                </div>
              ))}
            </div>

            {/* Table rectangle */}
            <div
              className="mx-1 border-4 rounded-lg flex items-center justify-center bg-gradient-to-br from-orange-50 to-orange-100"
              style={{
                width: '60px',
                height: `${FIXED_TABLE_HEIGHT}px`,
                borderColor: '#C87941'
              }}
            >
              <span className="text-xl font-bold opacity-30" style={{ color: '#C87941' }}>
                {tableNumber}
              </span>
            </div>

            {/* Right side */}
            <div className="flex flex-col" style={{ gap: `${GAP}px` }}>
              {rightSide.map((guest, idx) => (
                <div
                  key={`right-${idx}`}
                  className={`px-1 rounded-md border transition-all flex items-center ${guest.name && isHighlighted(guest)
                    ? 'bg-yellow-300 border-yellow-600 font-bold shadow-lg transform scale-110 z-20'
                    : guest.name ? 'bg-white border-gray-300' : 'bg-gray-50 border-gray-200'
                    }`}
                  style={{
                    width: `${SEAT_WIDTH}px`,
                    height: `${SEAT_HEIGHT}px`,
                    fontSize: '8px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    paddingLeft: '4px'
                  }}
                >
                  {guest.name || '-'}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderCircularTable = (tableNumber) => {
    const tableGuests = SEATING_DATA.filter(g => g.table === tableNumber);

    // Get all position-numbered seats and sort them
    const seats = [];
    for (let i = 1; i <= 8; i++) {
      const guest = tableGuests.find(g => g.position === `pos-${i}`);
      if (guest) seats.push(guest);
    }

    const isHighlighted = (guest) => {
      return highlightedGuest &&
        highlightedGuest.table === guest.table &&
        highlightedGuest.position === guest.position;
    };

    const isTableHighlighted = highlightedGuest?.table === tableNumber;

    const SEAT_WIDTH = 85;
    const SEAT_HEIGHT = 24;
    const CIRCLE_RADIUS = 80; // Radius of the circle for seat placement
    const TABLE_SIZE = 90; // Size of the center circle

    return (
      <div
        ref={el => tableRefs.current[tableNumber] = el}
        className={`inline-block p-1 sm:p-2 lg:p-3 rounded-lg transition-all duration-300 transform scale-90 sm:scale-95 lg:scale-100 ${isTableHighlighted ? 'bg-yellow-50 shadow-xl !scale-100' : ''
          }`}
      >
        <h3 className="text-center text-xs sm:text-sm lg:text-base font-bold mb-1 sm:mb-2" style={{ color: '#C87941' }}>
          Table {tableNumber}
        </h3>
        <div className="flex flex-col items-center">
          {/* Circular layout with absolute positioning */}
          <div className="relative" style={{ width: `${(CIRCLE_RADIUS + SEAT_WIDTH / 2) * 2 + 20}px`, height: `${(CIRCLE_RADIUS + SEAT_HEIGHT / 2) * 2 + 20}px` }}>
            {/* Center circle (table) */}
            <div
              className="absolute border-4 rounded-full flex items-center justify-center bg-gradient-to-br from-orange-50 to-orange-100"
              style={{
                width: `${TABLE_SIZE}px`,
                height: `${TABLE_SIZE}px`,
                borderColor: '#C87941',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)'
              }}
            >
              <span className="text-xl font-bold opacity-30" style={{ color: '#C87941' }}>
                {tableNumber}
              </span>
            </div>

            {/* Seats arranged in a circle */}
            {seats.map((guest, idx) => {
              // Equal vertical spacing: 8 positions with spacing of RADIUS/2
              // Positions go clockwise from top
              let x, y;
              const verticalSpacing = CIRCLE_RADIUS / 2;
              const topBottomInset = 15; // Bring top and bottom closer to center

              if (idx === 0) {
                // Position 1: Top (closer to center)
                y = -(CIRCLE_RADIUS - topBottomInset);
                x = 0;
              } else if (idx === 1) {
                // Position 2: Top-right
                y = -CIRCLE_RADIUS + verticalSpacing;
                x = Math.sqrt(CIRCLE_RADIUS * CIRCLE_RADIUS - y * y);
              } else if (idx === 2) {
                // Position 3: Right
                y = -CIRCLE_RADIUS + 2 * verticalSpacing;
                x = Math.sqrt(CIRCLE_RADIUS * CIRCLE_RADIUS - y * y);
              } else if (idx === 3) {
                // Position 4: Bottom-right
                y = -CIRCLE_RADIUS + 3 * verticalSpacing;
                x = Math.sqrt(CIRCLE_RADIUS * CIRCLE_RADIUS - y * y);
              } else if (idx === 4) {
                // Position 5: Bottom (closer to center)
                y = CIRCLE_RADIUS - topBottomInset;
                x = 0;
              } else if (idx === 5) {
                // Position 6: Bottom-left
                y = CIRCLE_RADIUS - verticalSpacing;
                x = -Math.sqrt(CIRCLE_RADIUS * CIRCLE_RADIUS - y * y);
              } else if (idx === 6) {
                // Position 7: Left
                y = CIRCLE_RADIUS - 2 * verticalSpacing;
                x = -Math.sqrt(CIRCLE_RADIUS * CIRCLE_RADIUS - y * y);
              } else {
                // Position 8: Top-left
                y = CIRCLE_RADIUS - 3 * verticalSpacing;
                x = -Math.sqrt(CIRCLE_RADIUS * CIRCLE_RADIUS - y * y);
              }

              return (
                <div
                  key={`pos-${idx + 1}`}
                  className={`absolute px-1 rounded-md border text-center transition-all flex items-center justify-center ${isHighlighted(guest)
                    ? 'bg-yellow-300 border-yellow-600 font-bold shadow-lg scale-110 z-20'
                    : 'bg-white border-gray-300'
                    }`}
                  style={{
                    width: `${SEAT_WIDTH}px`,
                    height: `${SEAT_HEIGHT}px`,
                    fontSize: '8px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    left: '50%',
                    top: '50%',
                    transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`
                  }}
                >
                  {guest.name}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FDF8F3' }}>
      {/* Header */}
      <div className="text-center py-4 md:py-6 px-4 overflow-x-hidden">
        <h1 className="text-2xl md:text-4xl font-bold mb-3" style={{ color: '#C87941' }}>
          Seating Chart
        </h1>
        <a
          href="/"
          className="inline-block px-3 py-1.5 rounded text-white text-sm mb-4"
          style={{ backgroundColor: '#C87941' }}
        >
          ← Back to Home
        </a>
      </div>

      {/* Sticky Search & Minimap Section */}
      <div className="sticky top-0 z-30 py-4 px-4 shadow-md overflow-x-hidden" style={{ backgroundColor: '#FDF8F3' }}>
        {/* Search box with autocomplete */}
        <div className="max-w-md mx-auto mb-4 relative">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
            <input
              ref={inputRef}
              type="text"
              value={searchQuery}
              onChange={handleSearch}
              onKeyDown={handleKeyDown}
              onFocus={() => {
                if (filteredGuests.length > 0) setShowDropdown(true);
              }}
              placeholder="Type your name to find your seat..."
              className="w-full pl-9 pr-3 py-2 md:py-3 rounded-lg border-2 focus:outline-none text-base"
              style={{ borderColor: '#C87941' }}
            />
          </div>

          {/* Autocomplete dropdown */}
          {showDropdown && (
            <div
              ref={dropdownRef}
              className="absolute z-50 w-full mt-1 bg-white rounded-lg shadow-lg border-2"
              style={{ borderColor: '#C87941' }}
            >
              {filteredGuests.map((guest, index) => (
                <div
                  key={`${guest.table}-${guest.position}`}
                  className={`px-4 py-2 cursor-pointer hover:bg-orange-50 text-sm ${index === selectedIndex ? 'bg-orange-100' : ''
                    }`}
                  onClick={() => selectGuest(guest)}
                  onMouseEnter={() => setSelectedIndex(index)}
                >
                  <span className="font-medium">{guest.name}</span>
                  <span className="text-gray-500 ml-2">- Table {guest.table}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Display selected guest info */}
        {highlightedGuest && (
          <p className="text-green-600 font-medium text-center mb-4">
            {highlightedGuest.name} - Table {highlightedGuest.table}
          </p>
        )}

        {/* Table Layout Minimap */}
        {renderTableLayoutMinimap()}
      </div>

      {/* Tables Layout */}
      <div className="container mx-auto px-2 sm:px-4 pb-8 overflow-x-hidden">
        {/* Rectangular Tables (4, 3, 2, 1) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2 sm:gap-4 mb-6 justify-items-center">
          {[4, 3, 2, 1].map(num => (
            <div key={`table-${num}`} className="w-full flex justify-center">
              {renderRectangularTable(num)}
            </div>
          ))}
        </div>

        {/* Circular Tables (6, 5) */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8">
          {[6, 5].map(num => (
            <div key={`table-${num}`}>
              {renderCircularTable(num)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SeatingChart;
